import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

let agent: BrowserAgent | undefined;

/**
 * Native console, captured before the agent wraps it. Output written through it
 * is visible in DevTools but not auto-captured as a New Relic log, for errors
 * that are already reported another way (noticeError, LoggerService).
 */
export const nativeConsole = {
    error: console.error.bind(console),
};

/**
 * Starts the New Relic Browser agent from the runtime config (window.__env),
 * rendered by entrypoint.sh. Does nothing when not configured (e.g. ng serve).
 */
export function startNewRelic(): void {
    const env = window.__env ?? {};

    if (!env.nrLicenseKey || env.nrLicenseKey.startsWith('${')) {
        return;
    }

    agent = new BrowserAgent({
        init: {
            distributed_tracing: { enabled: true },
            privacy: { cookies_enabled: true },
        },
        info: {
            beacon: env.nrBeacon,
            errorBeacon: env.nrBeacon,
            licenseKey: env.nrLicenseKey,
            applicationID: env.nrApplicationId,
            sa: 1,
        },
        loader_config: {
            accountID: env.nrAccountId,
            trustKey: env.nrTrustKey,
            agentID: env.nrAgentId,
            licenseKey: env.nrLicenseKey,
            applicationID: env.nrApplicationId,
        },
    });
}

export function getNewRelicAgent(): BrowserAgent | undefined {
    return agent;
}
